import { createFileRoute, Link } from '@tanstack/react-router'
import { PencilIcon, PlusIcon } from 'lucide-react'

import { Button } from '@/components/ui/button.tsx'
import { ScrollArea } from '@/components/ui/scroll-area.tsx'
import { Empty } from '@/components/empty.tsx'
import { Breadcrumbs } from '@/components/layout/breadcrumbs.tsx'
import { PageTitle } from '@/components/layout/page-title.tsx'
import { QuerySpinner } from '@/components/spinner/query-spinner.tsx'
import { useFindAttributeGroups } from '@/features/attribute-groups/hooks/use-find-attribute-groups.ts'

export const Route = createFileRoute(
  '/_authenticated/settings/attribute-groups/'
)({
  component: AttributeGroupsList,
})

function AttributeGroupsList() {
  const findAttributesGroupsQuery = useFindAttributeGroups()
  const attributesGroups = findAttributesGroupsQuery.data?.data

  return (
    <>
      <Breadcrumbs
        items={[
          { name: 'Impostazioni' },
          {
            name: 'Gruppi Attributi',
            to: '/settings/attribute-groups',
          },
        ]}
      />

      <ScrollArea className="max-w-screen-sm p-4">
        <PageTitle className="flex justify-between">
          Gruppi Attributi
          <Link to="/settings/attribute-groups/create">
            <Button variant="outline" size="sm">
              <PlusIcon /> Nuovo
            </Button>
          </Link>
        </PageTitle>

        <QuerySpinner
          query={findAttributesGroupsQuery}
          wrapperClassName="py-10"
        >
          <ul role="list" className="divide-y divide-gray-100">
            {attributesGroups?.map((attributeGroup, index) => (
              <li
                key={index}
                className="flex items-center justify-between gap-x-6 py-5"
              >
                <div className="flex min-w-0 gap-x-4">
                  <div className="min-w-0 flex-auto">
                    <p className="text-sm/6 font-semibold text-gray-900">
                      {attributeGroup.name}
                    </p>

                    {/*<p className="mt-1 line-clamp-1 text-xs/5 text-gray-500">*/}
                    {/*  <b>Descrizione</b>: {attributeGroup.description}*/}
                    {/*</p>*/}
                    {attributeGroup.attributes_on_group?.length > 0 && (
                      <p className="mt-1 text-xs/5 text-gray-500">
                        <b>Attributi:</b>{' '}
                        {attributeGroup.attributes_on_group
                          ?.map(({ attribute }) => attribute.name)
                          .join(', ')}
                      </p>
                    )}
                    {attributeGroup.attributes_on_group?.length === 0 && (
                      <p className="mt-1 text-xs/5 text-gray-500">
                        Nessun attributo configurato
                      </p>
                    )}
                  </div>
                </div>
                <div>
                  <Link
                    to="/settings/attribute-groups/edit/$attributeGroupId"
                    params={{ attributeGroupId: attributeGroup.id }}
                  >
                    <Button variant="outline" size="icon">
                      <PencilIcon />
                    </Button>
                  </Link>
                </div>
              </li>
            ))}
          </ul>

          {!attributesGroups?.length && <Empty />}
        </QuerySpinner>
      </ScrollArea>
    </>
  )
}
